import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  wrapper: { flex: 1, marginBottom: 16, gap: 16 },
  modal: {
    width: 384,
    minHeight: 320,
    borderRadius: 20,
    paddingVertical: 32,
    paddingHorizontal: 24,
  },
  container: {
    display: 'flex',
    gap: 16,
  },
  headerContainer: { display: 'flex', gap: 16 },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 33.6,
  },
  description: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 24,
    marginTop: 16,
  },
  ctaContainer: {
    flexDirection: 'row',
    gap: 8,
    width: '100%',
  },
  videoContainer: {
    minHeight: 284,
  },
});

export const mobileStyle = StyleSheet.create({
  title: {
    fontSize: 20,
  },
});
